import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'textTransform' })
export class TextTransformPipe implements PipeTransform {
    transform(value: string, transformer: (input: string) => string): string {
        return transformer(value);
    }
}
